// DO NOT EDIT
  // this file is generated by /internals/populate-icons script
  import * as React from 'react'
  // @ts-ignore
  import { Save } from 'react-feather'
  import IconBase from './../../IconBase'

  function IconSave(props: any) {
    return <IconBase icon={Save} {...props} />
  }

  export default IconSave
  